export const SHARE_JOB_TYPES = {
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    TWITTER: 'twitter',
}